import React from 'react';
import { Scale } from 'lucide-react';
import { RULE_BY_ID } from '@/data/manual/rules';

export const RuleCallout = ({ rule, compact = false }) => {
  const r = typeof rule === 'string' ? RULE_BY_ID[rule] || { id: rule, title: 'Rule', text: rule } : rule;
  if (!r) return null;
  return (
    <div data-testid={`rule-${r.id}`} className={`flex gap-2.5 rounded-lg border border-amber-300 bg-amber-50/80 ${compact ? 'px-3 py-2' : 'px-3.5 py-3'} break-inside-avoid`}>
      <Scale className="w-4 h-4 text-amber-700 shrink-0 mt-0.5" />
      <div className="min-w-0">
        <div className="text-xs font-bold uppercase tracking-wide text-amber-800">Rule · {r.title}</div>
        {!compact && <p className="text-sm text-amber-950 mt-0.5 leading-relaxed">{r.text}</p>}
      </div>
    </div>
  );
};
